/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PermissionSearchOrderBy } from './PermissionSearchOrderBy';
import {
    PermissionSearchOrderByFromJSON,
    PermissionSearchOrderByFromJSONTyped,
    PermissionSearchOrderByToJSON,
    PermissionSearchOrderByToJSONTyped,
} from './PermissionSearchOrderBy';
import type { SortOrder } from './SortOrder';
import {
    SortOrderFromJSON,
    SortOrderFromJSONTyped,
    SortOrderToJSON,
    SortOrderToJSONTyped,
} from './SortOrder';

/**
 * 
 * @export
 * @interface PermissionSearchSortingQuery
 */
export interface PermissionSearchSortingQuery {
    /**
     * 
     * @type {PermissionSearchOrderBy}
     * @memberof PermissionSearchSortingQuery
     */
    orderBy?: PermissionSearchOrderBy;
    /**
     * 
     * @type {SortOrder}
     * @memberof PermissionSearchSortingQuery
     */
    order?: SortOrder;
}



/**
 * Check if a given object implements the PermissionSearchSortingQuery interface.
 */
export function instanceOfPermissionSearchSortingQuery(value: object): value is PermissionSearchSortingQuery {
    return true;
}

export function PermissionSearchSortingQueryFromJSON(json: any): PermissionSearchSortingQuery {
    return PermissionSearchSortingQueryFromJSONTyped(json, false);
}

export function PermissionSearchSortingQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionSearchSortingQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'orderBy': json['orderBy'] == null ? undefined : PermissionSearchOrderByFromJSON(json['orderBy']),
        'order': json['order'] == null ? undefined : SortOrderFromJSON(json['order']),
    };
}

export function PermissionSearchSortingQueryToJSON(json: any): PermissionSearchSortingQuery {
    return PermissionSearchSortingQueryToJSONTyped(json, false);
}

export function PermissionSearchSortingQueryToJSONTyped(value?: PermissionSearchSortingQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderBy': PermissionSearchOrderByToJSON(value['orderBy']),
        'order': SortOrderToJSON(value['order']),
    };
}

